import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Header, Icon, Anchor, Button, Footnote } from 'Components/core';
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import InfoBox from 'Components/InfoBox';
 

// Images
import contactusImage from './images/contact_us@2x.png';
 
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
 

 

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_CONTACT_US);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container
         
          column
          maxWidth
          style={{ margin: 'auto' }}
        >
        
          <InfoBox
          compact
            header="Additional Information"
            longText={
              state.contactus ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: replaceAnchor(state.contactus)
                  }}
                ></span>
              ) : (
                <span>
                 <p> Once you’ve enrolled in your new plan, you’ll have access to personalized support and the largest network of care providers in the nation.<sup>1</sup> Make the most of your benefits so you can be your healthiest self by:
                  </p>
                  <ul>

<li>Looking out for your health plan ID card, which will arrive through the mail or digitally through the app.</li>
<li>Selecting your primary care doctor if you haven’t already.  </li>
<li>Scheduling your annual wellness visit.</li>
</ul>
<Footnote style={{color:'#ffffff'}}> <sup>1</sup> Blue Cross Blue Shield Association: About Us: The Blue Cross Blue Shield System: <Anchor to="https://www.bcbs.com/"  style={{color:'#ffffff'}} target="_blank">bcbs.com</Anchor></Footnote>
 
 
 

                </span>
              )
            }
            image={contactusImage}
          ></InfoBox>
        </Container>
      )}
    </Subscribe>
  );
};
